import type { ThemeKey } from '../types';

// Force light mode always
let systemThemeCache: ThemeKey = 'light';

let themeChangeCallback: ((newTheme: ThemeKey) => void) | undefined;

export function getSystemTheme() {
  return 'light' as ThemeKey;
}

function handleSystemThemeChange(_e: MediaQueryListEventMap['change']) {
  // Always stay light
}

export function setSystemThemeChangeCallback(callback: (newTheme: ThemeKey) => void) {
  themeChangeCallback = callback;
}
